import React from 'react';
import AuthForm from './auth-form.jsx';
import AuthShell from './auth-shell.jsx';

function AuthClassicSignUp() {
	return <AuthShell variant="classic"><AuthForm variant="classic" mode="sign-up" /></AuthShell>;
}

export default AuthClassicSignUp;
